import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export const create = () => {
	return class extends Controller {
		static targets = ['content', 'openButton'];
		static values = { flipClass: { type: String, default: 'is-flipped' } };

		connect() {
			this.syncInert();
			useClickOutside(this);
		}

		open(event) {
			event.preventDefault();
			if (!this.hasOpenButtonTarget) return;
			if (this.element.classList.contains(this.flipClassValue)) return;
			this.element.classList.add(this.flipClassValue);
			this.syncInert();
			this.openButtonTarget.setAttribute('aria-expanded', 'true');
		}

		toggle(event) {
			event.preventDefault();
			if (this.element.classList.contains(this.flipClassValue)) {
				this.collapse();
				return;
			}

			this.open(event);
		}

		close(event) {
			event.preventDefault();
			this.collapse();
		}

		clickOutside(event) {
			if (!this.element.classList.contains(this.flipClassValue)) return;
			event.preventDefault();
			this.collapse();
		}

		collapse() {
			if (!this.element.classList.contains(this.flipClassValue)) return;
			if (!this.hasOpenButtonTarget) return;
			this.element.classList.remove(this.flipClassValue);
			this.syncInert();
			this.openButtonTarget.setAttribute('aria-expanded', 'false');
			requestAnimationFrame(() => this.openButtonTarget.focus({ preventScroll: true }));
		}

		syncInert() {
			const flipped = this.element.classList.contains(this.flipClassValue);
			const contentTargets = this.contentTargets;
			const expanded = contentTargets[contentTargets.length - 1];
			const collapsed = contentTargets.slice(0, -1);
			if (!collapsed.length || !expanded) return;
			if (flipped) {
				collapsed.forEach((target) => target.setAttribute('inert', ''));
				expanded.removeAttribute('inert');
			} else {
				collapsed.forEach((target) => target.removeAttribute('inert'));
				expanded.setAttribute('inert', '');
			}
		}
	};
};
